import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './shopping-promo.component.scss';
var ShoppingPromo = /** @class */ (function (_super) {
    tslib_1.__extends(ShoppingPromo, _super);
    function ShoppingPromo(element) {
        return _super.call(this, element) || this;
    }
    ShoppingPromo.prototype.init = function () {
    };
    ShoppingPromo.prototype.bindEvents = function () {
    };
    return ShoppingPromo;
}(Base));
export { ShoppingPromo };



//////////////////
// WEBPACK FOOTER
// ./components/shopping-promo/shopping-promo.component.ts
// module id = 507
// module chunks = 0